import { useEffect, useState } from 'react';
import { useAppDispatch, useAppSelector } from '../../Hooks/Hooks';
import { RootState } from '../../Redux/Store';
import { fbLogEvent } from '../../Helpers/FirebaseHelper';
import { EVENT, SCREEN } from '../../Constants/AnalyticsConstants';
import { OK_TEXT } from '../../Constants/Constants';
import UserProfile from '../../Components/Profile/UserProfile/UserProfile';
import DeviceInfo from '../../Components/Shared/DeviceInfo/DeviceInfo';
import DeviceInfoTable from '../../Components/Shared/DeviceInfoTable/DeviceInfoTable';
import CustomModal from '../../Components/Shared/CustomModal/CustomModal';
import './Profile.scss';
import { getContentStackData } from '../../Redux/Reducers/ContentOrConfigSlice';

interface IProfileProps {}

const Profile = (props: IProfileProps) => {
  const dispatch = useAppDispatch();

  const [deviceInfoModalProps, setDeviceInfoModalProps] = useState({
    isModalOpen: false,
  });
  const { contentStackData } = useAppSelector((state: RootState) => state.ContentOrConfig);
  useEffect(() => {
    if (
      [
        ...(contentStackData?.accordion_content ?? []),
        ...(contentStackData?.tabbed_accordion_content ?? []),
      ]?.length === 0
    )
      dispatch(
        getContentStackData({
          queryPayload: {
            contentType: 'tabbed_content,accordion_content,tabbed_accordion_content',
          },
        }),
      );
  }, [contentStackData?.accordion_content, contentStackData?.tabbed_accordion_content, dispatch]);
  const showBanner = useAppSelector((state: RootState) => state.ContentOrConfig?.showBanner);
  const handleDeviceClick = () => {
    fbLogEvent(EVENT.SV_DEVICE_INFO, {
      screen: SCREEN.DEVICE_INFO_MODAL,
      lead: SCREEN.PROFILE,
    });
    const modalProps = {
      isModalOpen: true,
      title: 'Device Info',
      titleIcon: '/oo/assets/icon/info.svg',
      additionalCssClass: 'DeviceInfo_Modal',
      children: (
        <div>
          <DeviceInfoTable />
        </div>
      ),
      buttons: [
        {
          title: OK_TEXT,
          type: 'primary-cta-btn',
          onClick: () => {
            setDeviceInfoModalProps({ isModalOpen: false });
          },
        },
      ],
    };
    setDeviceInfoModalProps(modalProps);
  };

  return (
    <div className={`Profile${showBanner ? ' AlertBannerVisible' : ''}`}>
      <CustomModal {...deviceInfoModalProps} />
      <div className="Device_Container">
        <DeviceInfo handleDeviceClick={handleDeviceClick} />
      </div>
      <h1>My Profile</h1>
      <div>
        <UserProfile />
      </div>
    </div>
  );
};

export default Profile;
